// eslint-disable-next-line import/prefer-default-export
export const ShiftlineFilterSelectionTabs = Object.freeze({
    Unselected: 'Unselected',
    Selected: 'Selected',
});
